import React, { Suspense } from "react";
import { FpLoadingIcon } from "@fortius/prime-ui";
import { Route, Switch } from "react-router-dom";

const SignupRoute = React.lazy(() => import("./signupRoute"));
const SecurePaymentRoute = React.lazy(() => import("./securePaymentRoute"));

export const App = () => {
  return (
    <Suspense fallback={<FpLoadingIcon fullScreen />}>
      <Switch>
        <Route path={`/payment`}>
          <SecurePaymentRoute />
        </Route>
        <Route path={`/`}>
          <SignupRoute />
        </Route>
      </Switch>
    </Suspense>
  );
};
